"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Fri Aug 24 2018
 */

var CodebookLookupSequence_1 = require("../../core/model/codebook/CodebookLookupSequence");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var FlagSet_1 = require("../../core/model/FlagSet");

var PriceClassificationFlag_1 = require("./PriceClassificationFlag");

exports.PRICE_FLAG_LOOKUP = CodebookLookupSequence_1.CodebookLookupSequence.PriceClassification;
var PriceClassification;

(function (PriceClassification) {
  PriceClassification["Regular"] = "REGULAR";
  PriceClassification["Outlier"] = "OUTLIER";
  PriceClassification["Promo"] = "PROMO";
})(PriceClassification = exports.PriceClassification || (exports.PriceClassification = {}));
/**
 * Class for binding price flag for every price zone. The class is combination of several inputs:
 *    - autoFlag - result of automatic cleaning
 *    - userFlag - user override of automatic flag
 * the class combines these classification into `priceClassification` attribute
 *
 * @author RV
 * @author Stepan Mik
 */


var PriceClassificationsBinding =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(PriceClassificationsBinding, _DomainObject_1$Domai);

  /**
   *
   * @param autoFlag determined by automatic cleaning
   * @param userFlag set by user
   * @param externalFlag from input document with prices
   * @param flags flags with alerts
   * @param priceZoneId
   */
  function PriceClassificationsBinding(autoFlag, userFlag, externalFlag, priceZoneId) {
    var _this;

    var flags = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : new FlagSet_1.FlagSet(PriceClassificationFlag_1.PriceClassificationFlag);

    _classCallCheck(this, PriceClassificationsBinding);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PriceClassificationsBinding).call(this));
    _this.autoFlag = autoFlag;
    _this.userFlag = userFlag;
    _this.externalFlag = externalFlag;
    _this.priceZoneId = priceZoneId;
    _this.flags = flags;
    return _this;
  }
  /**
   * Computes the final price classification used for further price calculations and displayed to users. There are some db
   * queries in CompetitorPriceRepositoryImpl using the same logic. They have to bee kept in sync with this method. If you
   * change the logic here, make sure those queries are still valid.
   */


  _createClass(PriceClassificationsBinding, [{
    key: "priceClassification",
    value: function priceClassification() {
      if (this.userFlag !== null) {
        return this.userFlag;
      }

      if (this.externalFlag === PriceClassification.Promo) {
        return this.externalFlag;
      }

      return this.autoFlag;
    }
  }]);

  return PriceClassificationsBinding;
}(DomainObject_1.DomainObject);

exports.PriceClassificationsBinding = PriceClassificationsBinding;

PriceClassificationsBinding.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(PriceClassificationsBinding.name);
  return {
    autoFlag: builder.senum('autoFlag', PriceClassification, exports.PRICE_FLAG_LOOKUP),
    userFlag: builder.opt(builder.senum('userFlag', PriceClassification, exports.PRICE_FLAG_LOOKUP)),
    externalFlag: builder.senum('externalFlag', PriceClassification, exports.PRICE_FLAG_LOOKUP),
    priceZoneId: builder.str('priceZoneId'),
    flags: builder.flags('flags', PriceClassificationFlag_1.PriceClassificationFlag)
  };
}();